import React from 'react'
import { x } from '@xstyled/styled-components'
import { Link } from 'react-router-dom'
import { Button } from '@pool/components/button/Button'
import { BlogCard } from '@pool/components/blog/BlogCard'
import { posts } from '@pool/content/blog/posts'

export function BlogPreview() {
  const latestPosts = posts.slice(0, 3)

  if (latestPosts.length === 0) return null

  return (
    <x.section
      w={{ _: '100%', maxWidth: 'midWidth' }}
      mx="auto"
      mt={{ _: '75px', xl: '130px' }}
      pt={{ _: '75px', xl: '130px' }}
      px={{ _: '30px', md: '60px' }}>
      <x.div
        display="flex"
        justifyContent="space-between"
        alignItems={{ _: 'flex-start', md: 'flex-end' }}
        flexDirection={{ _: 'column', md: 'row' }}
        gap="20px"
        mb="70px">
        <x.div>
          <x.h3
            fontSize="20px"
            fontWeight="600"
            color="lightGreen"
            mb="15px"
            lineHeight="100%">
            Stay Updated
          </x.h3>
          <x.h2 fontSize="30px" fontWeight="600" color="lime" lineHeight="130%">
            Latest from the Blog
          </x.h2>
        </x.div>
        <Link to="/blog" style={{ textDecoration: 'none' }}>
          <Button variant="default" size="default" as="span">
            View All Posts
          </Button>
        </Link>
      </x.div>
      <x.div display="grid" gridTemplateColumns={{ _: 1, lg: 3 }} gap="34px">
        {latestPosts.map(({ frontmatter }) => (
          <BlogCard key={frontmatter.slug} frontmatter={frontmatter} />
        ))}
      </x.div>
    </x.section>
  )
}
